export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'LV',
        name: 'Latvian',
        normal: '­1234567890-fķūgjrmvnzēčžhšusildatec´ņbīkpoā,.ļ',
        shift: { 0: '?!«»$%/&×()_', 36: '°', 44: ';:' },
        alt: {
            1: '«',
            4: '€"’',
            8: ':',
            11: '–=',
            14: 'qģ',
            17: 'ŗwy',
            24: '[]',
            34: '€',
            36: '´',
            38: 'x',
            40: 'ķ',
            42: 'õ',
            44: '<>'
        },
        shift_alt: { 2: '@#$~^±', 11: '—;', 24: '{}', 36: '¨' },
        dk: { '~': 'oõOÕ ~', '´': 'oósścćeénńzźOÓSŚCĆEÉNŃZŹ ´', '°': 'aåeėgġzżAÅEĖZŻ °', '¨': 'oöaäuüOÖAÄUÜ ¨' }
    })
}
